import { render } from "./AddSupplierMasterdata.vue?vue&type=template&id=5516299c"
import script from "./AddSupplierMasterdata.vue?vue&type=script&lang=js"
export * from "./AddSupplierMasterdata.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__